module.exports = __webpack_public_path__ + "kn.svg?1459b5964fa6b1363d20ae8f6f5fc035";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/kn.svg
// module id = 1102
// module chunks = 27